// import React, { useState, useEffect } from 'react';
// import './index.css'; // Import your custom styles
// import logo1 from '../Images/logo1.jpeg'
// import lionslogo from '../Images/lionslogo.png'

// import header from '../Images/header.jpeg'

// const images = [logo1, lionslogo, header];
// // Image slider component
// const Slider = () => {

//     const [currentImageIndex, setCurrentImageIndex] = useState(0);
//     const imagesToShow = 3; // Show 3 images at once, adjust this as needed.
  
//     // Automatic image change every 3 seconds
//     useEffect(() => {
//       const interval = setInterval(() => {
//         setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
//       }, 3000);
  
//       return () => clearInterval(interval); // Cleanup on component unmount
//     }, []);
  
//     // Create an array with the images that should be shown
//     const visibleImages = images.concat(images).slice(currentImageIndex, currentImageIndex + imagesToShow);
  


//   return (
//     <div className='app-container '>
//    <div className="slider-container">
//       <div className="slider-images-wrapper">
//         {visibleImages.map((image, index) => (
//           <img
//             key={index}
//             src={image}
//             alt={`Slider Image ${index + 1}`}
//             className="slider-image"
//           />
//         ))}
//       </div>
//     </div>


//      <div className="text-container">
//        <div>
//          <img
//            src={header}
//            alt="Image 3"
//            className="card-image"
//          /> 
//               </div>
//          <div className="text-gray-700 leading-relaxed text-card">
//            <h2 className="text-xl font-bold text-blue-900">About Lions District 320C</h2>
//            <p>
//            Lions International District 320C is a part of Multiple District 320 , State of Telangana areas consist of part of Medchal Malkajgiri , Ranga Reddy and Hyderabad Revenue District. It has more than 3300+ Members and 106 Clubs . The District is currently headed by young and dynamic Lion K Harish Reddy an Industrialist from Cherlapally. He is ably supported by 1st Vice District Governor Lion V Krishna Prasad and Second Vice District Governor Lion K Inna Reddy and his cabinet members. Lions Business Network is formed first of its kind formed in this year with lions and non-lions as members to help and increase the business visibility for lions and young entrepreneurs
//            </p>
    
//        </div>
//      </div>

//    </div>
//   );
// };



// export default Slider


// import React, { useState, useEffect } from 'react';
// import './index.css'; // Import your custom styles
// import logo1 from '../Images/logo1.jpeg'
// import lionslogo from '../Images/lionslogo.png'
// import header from '../Images/header.jpeg'
// import logo2 from '../Images/logo2.jpeg'

// const images = [logo1, lionslogo, header, logo2];

// const Slider = () => {

//     const [currentImageIndex, setCurrentImageIndex] = useState(0);
//     const imagesToShow = 4; // Show 3 images at once, adjust this as needed.

//     // Automatic image change every 3 seconds
//     useEffect(() => {
//       const interval = setInterval(() => {
//         setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
//       }, 3000);

//       return () => clearInterval(interval); // Cleanup on component unmount
//     }, []);

//     // Create an array with the images that should be shown
//     const visibleImages = images.concat(images).slice(currentImageIndex, currentImageIndex + imagesToShow);

//     return (
//         <div className='app-container '>
//             <div className="slider-container">
//                 <div className="slider-images-wrapper">
//                     {visibleImages.map((image, index) => (
//                         <img
//                             key={index}
//                             src={image}
//                             alt={`Slider Image ${index + 1}`}
//                             className="slider-image"
//                         />
//                     ))}
//                 </div>
//             </div>

//             <div className="text-container">
//                 <div>
//                     <img
//                         src={header}
//                         alt="Image 3"
//                         className="card-image"
//                     />
//                 </div>
//                 <div className="text-gray-700 leading-relaxed text-card">
//                     <h2 className="text-xl font-bold text-blue-900">About Lions Multiple District 320</h2>
//                     <p className='leading-relaxed'>
//                 Multiple District 320 was formed in the year 2016-17 and was inaugurated by our International President Naresh Ji Agarwal on 7th July 2016 at Marriott Hotel Hyderabad.

// The Multiple District is the seventh Multiple District in India consisting of districts of Telangana State, part of Maharashtra, and part of Karnataka. There are nearly 22000+ members with 650+ clubs.</p>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Slider;



import React, { useState, useEffect } from 'react';
import './index.css';
import header from '../Images/header.jpeg';
import axios from 'axios';

const Slider = () => {
  const [images, setImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const imagesToShow = 4;

  // Fetch images from API
  useEffect(() => {
    axios.get('https://api.lbnhyderabad.com/admin-dashboard/api/images') // Replace with your API endpoint
      .then(res => {
        const data = res.data[0]; // Assuming one record
        const sideImages = [
          data.side_add_1,
          data.side_add_2,
          data.side_add_3,
          data.side_add_4,
          data.side_add_5,
          data.side_add_6
        ].filter(Boolean); // Remove nulls
        setImages(sideImages);
      })
      .catch(err => console.error('Error fetching side images:', err));
  }, []);

  // Auto-scroll logic
  useEffect(() => {
    if (images.length === 0) return;
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images]);

  // Slice the array to show 4 images at a time
  const visibleImages = images.concat(images).slice(currentImageIndex, currentImageIndex + imagesToShow);

  // return (
  //   <div className='app-container'>
  //     <div className="slider-container">
  //       <div className="slider-images-wrapper">
  //         {visibleImages.map((image, index) => (
            // <img
            //   key={index}
            //   src={image}
            //   alt={`Slider Image ${index + 1}`}
            //   className="slider-image"
            // />
  //         ))}
  //       </div>
  //     </div>

  //     <div className="text-container">
  //       <div>
  //         <img src={header} alt="Image 3" className="card-image" />
  //       </div>
  //       <div className="text-gray-700 leading-relaxed text-card">
  //         <h2 className="text-xl font-bold text-blue-900">About Lions Multiple District 320</h2>
  //         <p className='leading-relaxed'>
  //           Multiple District 320 was formed in the year 2016-17 and was inaugurated by our International President Naresh Ji Agarwal on 7th July 2016 at Marriott Hotel Hyderabad.
  //           <br /><br />
  //           The Multiple District is the seventh Multiple District in India consisting of districts of Telangana State, part of Maharashtra, and part of Karnataka. There are nearly 22000+ members with 650+ clubs.
  //         </p>
  //       </div>
  //     </div>
  //   </div>
  // );

return (
  <div
    style={{
      width: "100%",
      background: "#f5f7fb",
    }}
  >
    {/* PARTNERS SECTION */}

    <div
      style={{
        width: "100%",
        paddingTop: "90px",
        paddingBottom: "100px",
      }}
    >
      <h1
        style={{
          textAlign: "center",
          fontSize: "45px",
          fontWeight: "800",
          color: "#16233d",
          marginBottom: "70px",
        }}
      >
        Our Partners & Members
      </h1>

      {/* YOUR EXISTING visibleImages */}

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "35px",
          flexWrap: "wrap",
        }}
      >
        {visibleImages.map((image, index) => (
          <div
            key={index}
            style={{
              width: "240px",
              height: "180px",
              background: "#fff",
              borderRadius: "18px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              boxShadow:
                "0px 4px 14px rgba(0,0,0,0.08)",
            }}
          >
            {/* <div
              style={{
                width: "105px",
                height: "105px",
                borderRadius: "50%",
                background:
                  index % 3 === 0
                    ? "#2442B8"
                    : index % 3 === 1
                    ? "#f3b41b"
                    : "#f59e0b",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#fff",
                fontSize: "42px",
                fontWeight: "bold",
              }}
            >
              {index + 1}
            </div> */}

            {/* <p
              style={{
                marginTop: "18px",
                fontSize: "26px",
                color: "#394867",
                fontWeight: "500",
              }}
            >
              Partner {index + 1}
            </p> */}

            <img
              key={index}
              src={image}
              alt={`Slider Image ${index + 1}`}
              className="slider-image"
            />
          </div>
        ))}
      </div>
    </div>

    {/* ABOUT SECTION */}

    <div
      style={{
        width: "100%",
        background: "#eef3fb",
        padding: "120px 90px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // gap: "80px",
        flexWrap: "wrap",
      }}
    >
      {/* LEFT SIDE */}

      <div
        style={{
          position: "relative",
          width: "500px",
          height: "420px",
        }}
      >
        {/* YOUR EXISTING IMAGE */}

        <img
          src={header}
          alt="Image 3"
          className="card-image"
          style={{
            width: "300px",
            height: "350px",
            objectFit: "contain",
            borderRadius: "28px",
            position: "absolute",
            left: "0",
            top: "0",
            boxShadow:
              "0px 10px 25px rgba(0,0,0,0.15)",
          }}
        />

        {/* SAME IMAGE SECOND TIME */}

        {/* <img
          src={header}
          alt="Image 3"
          className="card-image"
          style={{
            width: "340px",
            height: "430px",
            objectFit: "cover",
            borderRadius: "28px",
            position: "absolute",
            right: "0",
            top: "70px",
            boxShadow:
              "0px 10px 25px rgba(0,0,0,0.15)",
          }}
        /> */}
      </div>

      {/* RIGHT SIDE */}

      <div
        style={{
          maxWidth: "760px",
        }}
      >
        <h2
          style={{
            fontSize: "42px",
            lineHeight: "78px",
            color: "#2142b2",
            fontWeight: "800",
            marginBottom: "35px",
          }}
        >
          About Lions Multiple District 320
        </h2>

        <p
          style={{
            fontSize: "20px",
            // lineHeight: "48px",
            color: "#444",
            marginBottom: "35px",
          }}
        >
          Multiple District 320 was formed in the year
          2016-17 and was inaugurated by our International
          President Naresh Ji Agarwal on 7th July 2016 at
          Marriott Hotel Hyderabad.
        </p>

        <p
          style={{
            fontSize: "20px",
            // lineHeight: "48px",
            color: "#444",
            marginBottom: "45px",
          }}
        >
          The Multiple District is the seventh Multiple
          District in India consisting of districts of
          Telangana State, part of Maharashtra, and part of
          Karnataka. There are nearly 22000+ members with
          650+ clubs.
        </p>

        <button
          style={{
            background: "#2442B8",
            color: "#fff",
            border: "none",
            padding: "22px 55px",
            borderRadius: "50px",
            fontSize: "24px",
            fontWeight: "600",
            cursor: "pointer",
            boxShadow:
              "0px 8px 18px rgba(36,66,184,0.3)",
          }}
        >
          Read More
        </button>
      </div>
    </div>
  </div>
);
};

export default Slider;
